import { getRecords } from '@/services/history'
import { Records, Session } from '@/services/types/history'
import { useCallback, useEffect, useState } from 'react'
import SJButton from '@/components/SJButton'
import SJNoData from '@/components/SJNoData'
import Card from './Card'
import { useNavigate } from 'react-router-dom'
import './index.less'
import GameItem from './GameItem'

type Props = {
  playerId: string
}
const GameInfo = ({ playerId }: Props) => {
  const navigate = useNavigate()
  const [records, setRecords] = useState<Session[]>([])
  const [hasMore, setHasMore] = useState(false)

  const [gameSel, setGameSel] = useState<number>(0)
  const onTypeChange = (val: number) => {
    setGameSel(val)
  }

  const fetchData = useCallback(async () => {
    if (playerId && gameSel > 0) {
      try {
        const res = (await getRecords({
          user_id: playerId,
          game_mode: gameSel,
          page: 1,
          size: 5,
        })) as unknown as Records
        setRecords(res.sessions)
        setHasMore(res.page < res.page_total)
      } catch (error) {}
    }
  }, [playerId, gameSel])

  useEffect(() => {
    fetchData()
  }, [playerId, gameSel, fetchData])

  const goHistroy = (item: Session) => {
    navigate(`/chess/history?sessionId=${item.session_id}&playerId=${playerId}`)
  }

  const goPlayerGames = () => {
    navigate('/chess/list', { state: { playerId, gameSel } })
  }

  return (
    <div className="game-info">
      <Card playerId={playerId} onTypeChange={onTypeChange} />
      <div className="game-list">
        {records.map((item) => (
          <GameItem key={item.session_id} game={item} onClick={() => goHistroy(item)}></GameItem>
        ))}
        {records.length ? undefined : <SJNoData text="暂无数据，快去和机器人互动吧" />}
      </div>
      {hasMore && (
        <SJButton type="primary" size="large" onClick={goPlayerGames}>
          查看更多对弈数据
        </SJButton>
      )}
    </div>
  )
}
export default GameInfo
